import script from "./LogsAnexo.vue?vue&type=script&setup=true&lang=js"
export * from "./LogsAnexo.vue?vue&type=script&setup=true&lang=js"

import "./LogsAnexo.vue?vue&type=style&index=0&id=5c58efbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c58efbe"]])

export default __exports__